import { useMemo, useState } from "react";
import { Wallet, CheckCircle2, XCircle, RotateCcw } from "lucide-react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import DataTable from "@/admin/DataTable";
import PaymentDrawer from "@/admin/PaymentDrawer";
import { useFetch, PageHeader, StatCard, Badge, PAYMENT, Loading, ErrorBox, fmtDate, fmtEur } from "@/admin/ui";

export default function AdminPayments() {
  const { data, error } = useFetch("/admin/payments");
  const [status, setStatus] = useState("all");
  const [q, setQ] = useState("");
  const [open, setOpen] = useState(null);
  const rows = useMemo(() => (data?.items || []).filter((p) =>
    (status === "all" || p.status === status) && `${p.name} ${p.email}`.toLowerCase().includes(q.trim().toLowerCase())), [data, status, q]);
  if (error) return <ErrorBox />;
  if (!data) return <Loading />;
  const s = data.summary;
  const columns = [
    { key: "name", label: "Alumno", render: (r) => <div><b>{r.name}</b><div className="adm-sub">{r.email}</div></div> },
    { key: "created_at", label: "Fecha", render: (r) => fmtDate(r.created_at, true) },
    { key: "amount", label: "Importe", num: true, render: (r) => <b>{fmtEur(r.amount)}</b> },
    { key: "status", label: "Estado", render: (r) => <Badge map={PAYMENT} value={r.status} testid={`admin-payment-status-${r.id}`} /> },
    { key: "method", label: "Método", render: (r) => <span className="adm-sub">{r.method || "—"}</span> },
    { key: "act", label: "Detalle", render: (r) => <button className="adm-btn sm" onClick={() => setOpen(r.id)} data-testid={`admin-payment-view-${r.id}`}>Ver detalle</button> },
  ];
  return (
    <div data-testid="admin-payments">
      <PageHeader title="Pagos" subtitle="Cobros registrados desde Stripe" />
      <div className="adm-grid adm-kpis" style={{ marginBottom: "1rem" }}>
        <StatCard label="Total facturado" value={fmtEur(s.total)} icon={Wallet} testid="admin-pay-total" />
        <StatCard label="Pagos exitosos" value={s.paid} icon={CheckCircle2} testid="admin-pay-ok" />
        <StatCard label="Pagos fallidos" value={s.failed} icon={XCircle} testid="admin-pay-failed" />
        <StatCard label="Reintentos" value={s.retries} hint="pagos con más de un intento" icon={RotateCcw} testid="admin-pay-retries" />
      </div>
      <div className="adm-row" style={{ marginBottom: "1rem" }}>
        <input className="adm-input" style={{ maxWidth: 320 }} placeholder="Buscar por alumno o email" value={q} onChange={(e) => setQ(e.target.value)} data-testid="admin-payments-search" />
        <Select value={status} onValueChange={setStatus}>
          <SelectTrigger className="w-[170px] bg-white" data-testid="admin-payments-filter"><SelectValue /></SelectTrigger>
          <SelectContent>
            <SelectItem value="all">Todos</SelectItem>
            <SelectItem value="paid">Pagados</SelectItem>
            <SelectItem value="failed">Fallidos</SelectItem>
          </SelectContent>
        </Select>
      </div>
      <DataTable columns={columns} rows={rows} testid="admin-payments-table" emptyText="Todavía no hay pagos registrados." />
      <PaymentDrawer id={open} onClose={() => setOpen(null)} />
    </div>
  );
}
